import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, vModelText as _vModelText, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center w-full h-full" }
const _hoisted_2 = { class: "flex items-center justify-between w-full absolute top-0 py-2 px-4 border-b border-gray-200" }
const _hoisted_3 = { class: "flex gap-2 items-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col items-center gap-4"
}
const _hoisted_6 = {
  key: 0,
  class: "text-center my-5 mx-10"
}
const _hoisted_7 = ["src"]

import {
  ref,
  onMounted,
  onBeforeUnmount,
  PropType,
  computed,
} from "vue";
import GenericCard from "./ui/GenericCard.vue";
import { ServiceItem, personBaseData, ServiceLink } from "../utils/interfaces";
import GenericButton from "./ui/GenericButton.vue";
import { events, type EventsChannel } from "aws-amplify/api";
import { useGeneralStore } from "../stores/general";
import ViewPDF from "./ui/ViewPDF.vue";
import { getCookie } from "../utils/cookies";
import { scrollToInput, convertToMiliseconds } from "../utils/common";

const MAX_RECONNECT_DELAY_MS = 30000;


export default /*@__PURE__*/_defineComponent({
  ...{ name: "ShowServices" },
  __name: 'ShowServices',
  props: {
  personData: {
    type: Object as PropType<personBaseData>,
    required: true,
  },
},
  emits: [
  "change-view",
  "resume-timer",
  "pause-timer",
  "set-timeout",
],
  setup(__props, { emit: __emit }) {



const generalStore = useGeneralStore();
const props = __props;
const emits = __emit;

const studiesChannelPath = `studies/${props.personData.idPersona}`;
const eventsChannel = ref<EventsChannel | null>(null);
let reconnectAttempts = 0;
let reconnectTimer: ReturnType<typeof setTimeout> | null = null;
const servicesList = ref([] as ServiceItem[]);
const servicesUsed = ref([] as string[]);
const currentService = ref({} as ServiceLink);
const currentServiceIndex = ref(0);
const wantApplyCurrentStudy = ref(false);
const resultados = ref([] as any[]);
const showFinalMessage = ref(false);
const loadingService = ref(false);
const email = ref(props.personData.email || "");
const loadingSendResults = ref(false);
const needEmail = ref(!props.personData.email);
const canSendEmail = ref(true);
const loadingContinue = ref(false);
const idEvent = ref();
const extraDataEvent = ref({});

const getServiceValue = (service: ServiceItem, key: string) => {
  const value = service?.[key as keyof ServiceItem];
  if (!value) return "";
  if (typeof value === "string") {
    return value.replace(/.*- /g, "");
  }
  return value;
};

function changeService(serviceUsed?: string, omit?: boolean) {
  if (!serviceUsed) return;
  loadingContinue.value = true;
  servicesUsed.value.push(serviceUsed);
  wantApplyCurrentStudy.value = false;
  if (omit) {
    resultados.value.push({
      key: currentService.value.key,
      name: currentService.value.name,
      archivo: null,
    });
  }
  currentServiceIndex.value++;
  loadingContinue.value = false;
  setIdleTime();
  if (servicesList.value.length === currentServiceIndex.value) {
    if (showFinalMessage.value === true) {
      endConsultation();
      return;
    }
    emits("pause-timer");
    showFinalMessage.value = true;
    return;
  }
  if (servicesList.value[currentServiceIndex.value].usoObligatorio) {
    handleApplyCurrentStudy();
  } else if (currentService.value.url) {
    currentService.value = {} as ServiceLink;
    return;
  }
}

async function handleApplyCurrentStudy() {
  if (currentService.value.url) {
    console.log("Reutilizando servicio...");
    wantApplyCurrentStudy.value = true;
    return;
  }
  loadingService.value = true;
  const currentServiceId = servicesList.value[currentServiceIndex.value].id;
  const booth = getCookie("booth") as string;
  const idCabina = generalStore.booth.id;
  const serviceLink = (await generalStore.getServiceLink({
    idServicio: currentServiceId,
    numeroPlanAsociado: props.personData.numeroPlanAsociado,
    referencia: props.personData.referencia,
    claveCabina: encodeURIComponent(booth),
    nroOrden: props.personData.nroOrden,
    idCabina: idCabina,
  })) as any;
  if (!serviceLink.url) {
    console.log("Algo salió mal...");
    loadingService.value = false;
    return;
  }
  currentService.value = serviceLink;
  wantApplyCurrentStudy.value = true;
  loadingService.value = false;
}

const currentServiceIsFinished = computed(() => {
  return resultados.value.some(
    (result) => result.key === currentService.value.key
  );
});

// eslint-disable-next-line @typescript-eslint/no-inferrable-types
function sortByArray(array: any[], arrayToSort: string[], key: string = "id") {
  const arraySorted = array.sort((a, b) => {
    const indexA = arrayToSort.indexOf(a[key]);
    const indexB = arrayToSort.indexOf(b[key]);

    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });
  return arraySorted;
}

function isEmailValid(email: string) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
}

function sendResults() {
  loadingSendResults.value = true;
  if (!isEmailValid(email.value)) {
    loadingSendResults.value = false;
    return;
  }
  const cardioRiskResultLink = resultados.value.find(
    (result) => result.key === "dd1a4c2e-148a-43ed-ad54-6ac9a998c72e"
  );
  if (cardioRiskResultLink) {
    generalStore
      .sendResults(
        cardioRiskResultLink.idCardioRisk,
        email.value
      )
      .then(() => {
        loadingSendResults.value = false;
        canSendEmail.value = false;
      });
  } else {
    loadingSendResults.value = false;
  }
}

async function endConsultation() {
  loadingContinue.value = true;
  await generalStore.endConsultation({
    numeroPlanAsociado: props.personData.numeroPlanAsociado,
    referencia: props.personData.referencia,
    idCabina: generalStore.booth.id,
  });
  loadingContinue.value = false;
  emits("change-view", "baseInformation");
}

async function createEvent(extraData: any) {
  const data = {
    idCabina: generalStore.booth.id,
    idSesion: generalStore.booth.idSesion,
    numeroPlanAsociado: props.personData.numeroPlanAsociado,
    referencia: props.personData.referencia,
    ...extraData,
  };
  extraDataEvent.value = { ...extraDataEvent.value, ...extraData };
  if (idEvent.value) data.id = idEvent.value;
  const res = (await generalStore.postEvent(data)) as any;
  idEvent.value = res.id;
}

function setIdleTime() {
  const customConfig = generalStore.getBooth.customConfig;
  const currentServiceId = servicesList.value[currentServiceIndex.value]?.id;
  const currentTimer = customConfig?.idleTimers?.[currentServiceId];
  if (currentTimer && currentTimer.time) {
    const time = convertToMiliseconds(currentTimer.time, currentTimer.unit);
    emits("set-timeout", time);
    emits("resume-timer");
  }
}

function handleStudyFinishedEvent(data: any) {
  if (!data.isFinished) return;
  resultados.value.push({
    key: currentService.value.key,
    name: currentService.value.name,
    archivo: data.archivo as any,
    idCardioRisk: data.idCardioRisk,
  });
  if (currentService.value.key === "1b026971-bcc4-4399-9a78-6ed1dbd76fe5") {
    currentService.value.url = "";
    changeService(currentService.value.key);
    generalStore.getConsultas(props.personData.idPersona).then((res: any) => {
      if (res.length > 0) {
        createEvent({
          ...extraDataEvent.value,
          idConsultaMedica: res[0].id,
        });
      }
    });
  } else {
    createEvent({
      ...extraDataEvent.value,
      cardioRisk: data.archivo?.location ? true : false,
      idCardioRisk: data.idCardioRisk ?? null,
    });
  }
}

async function connectEventsChannel() {
  try {
    const channel = await events.connect(studiesChannelPath);
    eventsChannel.value = channel;
    reconnectAttempts = 0;
    channel.subscribe({
      next: ({ event }: any) => handleStudyFinishedEvent(event),
      error: (err: any) => {
        console.error("[AppSync Events] error de suscripción", err);
        scheduleReconnect();
      },
    });
  } catch (err) {
    console.error("[AppSync Events] fallo al conectar", err);
    scheduleReconnect();
  }
}

function scheduleReconnect() {
  if (reconnectTimer) return;
  reconnectAttempts += 1;
  const delay = Math.min(1000 * 2 ** reconnectAttempts, MAX_RECONNECT_DELAY_MS);
  reconnectTimer = setTimeout(() => {
    reconnectTimer = null;
    eventsChannel.value?.close();
    connectEventsChannel();
  }, delay);
}

onMounted(() => {
  const coberturas = generalStore.getBooth.coberturas;
  servicesList.value = sortByArray(
    coberturas,
    ["dd1a4c2e-148a-43ed-ad54-6ac9a998c72e"],
    "id"
  );
  if (servicesList.value.length === 0) {
    showFinalMessage.value = true;
    return;
  }
  if (servicesList.value[0].usoObligatorio) {
    handleApplyCurrentStudy();
  }
  connectEventsChannel();
  setIdleTime();
});

function headerContinueBtn(key: string) {
  if (key && !showFinalMessage.value) changeService(key);
  else endConsultation();
}

onBeforeUnmount(() => {
  if (reconnectTimer) clearTimeout(reconnectTimer);
  eventsChannel.value?.close();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("p", null, "Resultados", -1)),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultados.value, (result) => {
          return (_openBlock(), _createElementBlock("li", {
            key: result.key
          }, [
            (result.archivo?.location)
              ? (_openBlock(), _createBlock(ViewPDF, {
                  key: 0,
                  textBtn: `Ver ${result.name}`,
                  title: result.name,
                  url: result.archivo.location
                }, null, 8, ["textBtn", "title", "url"]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createElementVNode("li", null, [
          _withDirectives(_createVNode(GenericButton, {
            variant: "primary",
            loading: loadingContinue.value,
            onClick: _cache[0] || (_cache[0] = () => headerContinueBtn(currentService.value?.key))
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode(" Continuar ")
            ])),
            _: 1,
            __: [5]
          }, 8, ["loading"]), [
            [_vShow, currentServiceIsFinished.value]
          ])
        ])
      ])
    ], 512), [
      [_vShow, resultados.value.length > 0]
    ]),
    (showFinalMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-center text-2xl" }, "Se han completado todos los estudios", -1)),
          _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-center text-lg" }, "Gracias por tu participación", -1)),
          _cache[13] || (_cache[13] = _createElementVNode("hr", { class: "my-4 border-gray-200 w-full" }, null, -1)),
          (resultados.value.filter((result) => result.archivo?.location).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[7] || (_cache[7] = _createElementVNode("p", null, "¿Deseas visualizar algún resultado?", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultados.value.filter((result) => result.archivo?.location), (result) => {
                  return (_openBlock(), _createBlock(ViewPDF, {
                    key: result.key,
                    textBtn: `Ver ${result.name}`,
                    title: result.name,
                    url: result.archivo.location
                  }, null, 8, ["textBtn", "title", "url"]))
                }), 128)),
                _cache[8] || (_cache[8] = _createElementVNode("hr", { class: "mb-4 border-gray-200 w-full" }, null, -1)),
                (needEmail.value)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(scrollToInput) && _unref(scrollToInput)(...args))),
                      type: "text",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((email).value = $event)),
                      class: "w-full border border-gray-300 rounded p-2",
                      placeholder: "Email"
                    }, null, 544)), [
                      [_vModelText, email.value]
                    ])
                  : _createCommentVNode("", true),
                _createVNode(GenericButton, {
                  variant: "primary",
                  loading: loadingSendResults.value,
                  onClick: sendResults,
                  disabled: !canSendEmail.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(canSendEmail.value
              ? "Enviar resultados por correo"
              : "Ya se envio el correo"), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"]),
                _cache[9] || (_cache[9] = _createElementVNode("hr", { class: "mb-4 border-gray-200 w-full" }, null, -1))
              ]))
            : _createCommentVNode("", true),
          _createVNode(GenericButton, {
            onClick: endConsultation,
            loading: loadingContinue.value,
            class: "w-full"
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode(" Finalizar ")
            ])),
            _: 1,
            __: [10]
          }, 8, ["loading"])
        ]))
      : (!wantApplyCurrentStudy.value)
        ? (_openBlock(), _createBlock(GenericCard, {
            key: 1,
            class: "max-w-1/2",
            title: `¿Se quiere aplicar '${getServiceValue(
        servicesList.value[currentServiceIndex.value],
        'nombre'
      )}'?`
          }, {
            default: _withCtx(() => [
              (getServiceValue(servicesList.value[currentServiceIndex.value], 'descripcion'))
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(getServiceValue(servicesList.value[currentServiceIndex.value], "descripcion")), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass({
          'grid grid-cols-2 gap-4': !getServiceValue(
            servicesList.value[currentServiceIndex.value],
            'usoObligatorio'
          ),
          'flex flex-col': getServiceValue(
            servicesList.value[currentServiceIndex.value],
            'usoObligatorio'
          ),
        })
              }, [
                (
            !getServiceValue(
              servicesList.value[currentServiceIndex.value],
              'usoObligatorio'
            )
          )
                  ? (_openBlock(), _createBlock(GenericButton, {
                      key: 0,
                      variant: "secondary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (changeService(servicesList.value[currentServiceIndex.value].id, true)))
                    }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createTextVNode(" Omitir ")
                      ])),
                      _: 1,
                      __: [14]
                    }))
                  : _createCommentVNode("", true),
                _createVNode(GenericButton, {
                  loading: loadingService.value,
                  onClick: handleApplyCurrentStudy
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getServiceValue(servicesList.value[currentServiceIndex.value], "usoObligatorio")
              ? "Sí"
              : "Aplicar"), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ], 2)
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true),
    (wantApplyCurrentStudy.value && currentService.value.url)
      ? (_openBlock(), _createElementBlock("iframe", {
          key: 2,
          src: `${currentService.value.url}&lang=es`,
          allow: "cross-origin-isolated; camera; microphone; geolocation;",
          referrerpolicy: "no-referrer",
          credentialless: "",
          allowfullscreen: "",
          class: _normalizeClass(
        wantApplyCurrentStudy.value && currentService.value.key === currentService.value.key
          ? 'w-[calc(100%-4rem)] h-[calc(100%-7rem)] mt-10'
          : 'w-0 h-0 mt-0'
      )
        }, null, 10, _hoisted_7))
      : _createCommentVNode("", true),
    (
        wantApplyCurrentStudy.value &&
        currentService.value.url &&
        !getServiceValue(servicesList.value[currentServiceIndex.value], 'usoObligatorio')
      )
      ? (_openBlock(), _createBlock(GenericButton, {
          key: 3,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (wantApplyCurrentStudy.value = false)),
          class: "absolute top-1 left-28",
          variant: "error"
        }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [
            _createTextVNode(" Cancelar ")
          ])),
          _: 1,
          __: [15]
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})